import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Label paginator untuk tabel di dalam modal Monitoring ("Showing rows 1 to 10 of 98"),
 * mengikuti gaya tabel lain di aplikasi.
 *
 * Disediakan lokal per komponen lewat `providers`, bukan mengandalkan `MatPaginatorIntl`
 * global yang kebetulan sudah diubah oleh `app-mai-material-bottom-table` di halaman induk.
 */
export function createMonitoringPaginatorIntl(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();
  intl.itemsPerPageLabel = '';
  intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) return '';

    const total = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < total ? Math.min(startIndex + pageSize, total) : startIndex + pageSize;

    return `Showing rows ${startIndex + 1} to ${endIndex} of ${total}`;
  };

  return intl;
}
